import React, { useState } from "react";
import { LANDMARK_LIST } from "../../constants/landmarkResources";

// 玻璃拟态基础样式
const glassBase = {
  background: "rgba(255, 255, 255, 0.22)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: "1px solid rgba(255, 255, 255, 0.35)",
  transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
};

export default function LandmarkCarousel({
  unlockedLandmarks,
  userShards,
  onUnlockLandmark,
  onEnterLandmark,
  onClose,
  onChangeSkin,
  onShowMessage
}) {
  // 轮播核心状态
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = LANDMARK_LIST.length;

  // 🔥 视频播放状态
  const [showVideo, setShowVideo] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  // 3D轮播位置计算（核心逻辑）
  const getCardStyle = (index) => {
    const diff = index - currentIndex;
    const normalizedDiff = ((diff % total) + total) % total;
    const offset = normalizedDiff > total / 2 ? normalizedDiff - total : normalizedDiff;

    const scale = 1 - Math.abs(offset) * 0.15;
    const translateX = offset * 180;
    const zIndex = 100 - Math.abs(offset) * 10;
    const opacity = 1 - Math.abs(offset) * 0.2;

    return {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: `translate(-50%, -50%) translateX(${translateX}px) scale(${scale})`,
      zIndex,
      opacity,
      width: "450px",
      height: "300px",
      borderRadius: "24px",
      overflow: "hidden",
      cursor: "pointer",
      pointerEvents: offset === 0 ? "auto" : "none",
      ...glassBase,
    };
  };

  // 左右切换
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  // 当前激活的地标
  const currentLandmark = LANDMARK_LIST[currentIndex];
  
  // 🔥 修复：埃菲尔铁塔 ID=7（匹配你的配置）
  const isEiffelTower = currentLandmark.id === 7 || currentLandmark.name.includes("埃菲尔");
  const isUnlocked = isEiffelTower || unlockedLandmarks.includes(currentLandmark.id);

  // 切换当前地标为壁纸
  const handleSetLandmarkBg = () => {
    if (!isUnlocked) {
      onShowMessage("❌ 请先解锁该地標！");
      return;
    }
    onChangeSkin(`landmark_${currentLandmark.id}`);
    onShowMessage(`✅ 已切换：${currentLandmark.name} 壁纸`);
  };

  // 🔥 核心：进入地图 → 播放对应视频
  const handlePlayVideo = (landmark) => {
    setCurrentVideoUrl(landmark.videoUrl);
    setShowVideo(true);
  };

  return (
    <>
      {/* 地标轮播弹窗 */}
      <div style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.85)",
        zIndex: 999999999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
      >
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "4vh",
            right: "5vw",
            background: "none",
            border: "none",
            fontSize: "36px",
            color: "#fff",
            cursor: "pointer",
            zIndex: 1000,
          }}
        >×</button>

        {/* 地标标题 */}
        <div style={{
          textAlign: "center",
          marginBottom: "60px",
          zIndex: 100,
        }}
        onClick={(e) => e.stopPropagation()}
        >
          <h1 style={{
            color: "#fff",
            fontSize: "42px",
            fontWeight: 700,
            margin: 0,
            letterSpacing: "2px",
          }}>{currentLandmark.name}</h1>
          <p style={{
            color: "rgba(255,255,255,0.7)",
            fontSize: "24px",
            margin: "8px 0 0 0",
            letterSpacing: "1px",
          }}>{currentLandmark.frenchName}</p>
        </div>

        {/* 轮播卡片容器 */}
        <div style={{
          position: "relative",
          width: "100%",
          height: "350px",
          maxWidth: "1200px",
        }}
        onClick={(e) => e.stopPropagation()}
        >
          {/* 所有卡片 */}
          {LANDMARK_LIST.map((landmark, index) => (
            <div key={landmark.id} style={getCardStyle(index)}>
              <img
                src={landmark.bgUrl}
                alt={landmark.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src = "https://picsum.photos/450/300";
                }}
              />
            </div>
          ))}

          {/* 左箭头 */}
          <button
            onClick={handlePrev}
            style={{
              position: "absolute",
              left: "5vw",
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(255,255,255,0.2)",
              backdropFilter: "blur(10px)",
              border: "none",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "32px",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1000,
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.35)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.2)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1)";
            }}
          >‹</button>

          {/* 右箭头 */}
          <button
            onClick={handleNext}
            style={{
              position: "absolute",
              right: "5vw",
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(255,255,255,0.2)",
              backdropFilter: "blur(10px)",
              border: "none",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "32px",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1000,
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.35)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.2)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1)";
            }}
          >›</button>
        </div>

        {/* 底部操作按钮 */}
        <div style={{
          marginTop: "60px",
          zIndex: 100,
          textAlign: "center"
        }}
        onClick={(e) => e.stopPropagation()}
        >
          {isUnlocked ? (
            <>
              {/* 🔥 点击播放视频 */}
              <button
                onClick={() => handlePlayVideo(currentLandmark)}
                style={{
                  padding: "16px 60px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: "50px",
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#fff",
                  cursor: "pointer",
                  boxShadow: "0 8px 24px rgba(102,126,234,0.4)",
                  transition: "all 0.3s ease",
                  marginBottom: "12px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                进入地图
              </button>

              <button
                onClick={handleSetLandmarkBg}
                style={{
                  padding: "12px 40px",
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "50px",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#fff",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "block",
                  margin: "0 auto 12px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                }}
              >
                🌄 使用当前地标壁纸
              </button>
            </>
          ) : (
            <button
              onClick={() => onUnlockLandmark(currentLandmark)}
              style={{
                padding: "16px 60px",
                background: "linear-gradient(135deg, #ffb74d 0%, #ff9800 100%)",
                border: "none",
                borderRadius: "50px",
                fontSize: "20px",
                fontWeight: 600,
                color: "#fff",
                cursor: userShards >= currentLandmark.needShards ? "pointer" : "not-allowed",
                boxShadow: "0 8px 24px rgba(255,183,77,0.4)",
                transition: "all 0.3s ease",
                opacity: userShards >= currentLandmark.needShards ? 1 : 0.6,
              }}
              onMouseEnter={(e) => {
                if (userShards >= currentLandmark.needShards) {
                  e.currentTarget.style.transform = "scale(1.05)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              解锁地图 · {currentLandmark.needShards} 🧩
            </button>
          )}

          {/* 碎片余额显示 */}
          <div style={{
            textAlign: "center",
            marginTop: "8px",
            color: "rgba(255,255,255,0.8)",
            fontSize: "16px",
          }}>
            当前碎片：{userShards} 🧩
          </div>
        </div>
      </div>

      {/* 🔥 视频播放弹窗（最高层级） */}
      {showVideo && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.98)",
          zIndex: 999999999 + 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => setShowVideo(false)}
        >
          {/* 关闭按钮 */}
          <button
            onClick={() => setShowVideo(false)}
            style={{
              position: "absolute",
              top: "4vh",
              right: "5vw",
              background: "none",
              border: "none",
              fontSize: "40px",
              color: "#fff",
              cursor: "pointer",
              zIndex: 9999,
            }}
          >×</button>

          {/* 视频播放器 */}
          <video
            src={currentVideoUrl}
            autoPlay
            controls
            playsInline
            onEnded={() => setShowVideo(false)}
            style={{
              maxWidth: "95%",
              maxHeight: "90vh",
              borderRadius: "12px",
              boxShadow: "0 0 50px rgba(0,0,0,0.8)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}